/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUnderlineRussian = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M464 705V128h180v569q0 129 69 188t194 59q113 0 223-34t211-84V128h180v1536h-180V973q-106 56-220 93t-236 37q-96 0-173-25t-133-75-85-124-30-174zm-80 1215h1152v128H384v-128z"
    }));
export default SvgUnderlineRussian;
